import anime from 'animejs';
import { ProgressBar } from './ProgressBar';
import { ProgressPercentage } from './ProgressPercentage';
import { ProgressProps } from './index';
import klass from './Progress.module.scss';

export class ProgressAnimationController {
  private bar: ProgressBar;
  private percentage: ProgressPercentage;
  private timeline?: anime.AnimeTimelineInstance;

  constructor(bar: ProgressBar, percentage: ProgressPercentage) {
    this.bar = bar;
    this.percentage = percentage;
  }

  animate(props: Pick<ProgressProps, 'start' | 'end' | 'duration' | 'easing' | 'auto'>) {
    const { start = 0, end, duration = 500, easing = 'easeOutCubic' } = props;

    if (this.timeline) {
      this.timeline.pause();
    }

    const $fill = this.bar.element().querySelector(`.${klass.progress_bar_fill}`);
    const $percentage = this.percentage.element().querySelector(`.${klass.progress_percentage_value}`);

    if (!$fill || !$percentage) return;

    this.timeline = anime.timeline({
      duration,
      easing,
    });

    // 프로그레스 바와 퍼센트를 동시에 애니메이션
    this.timeline
      .add(
        {
          targets: $fill,
          width: `${Math.min(100, Math.max(0, end))}%`,
        },
        0,
      ) // 0ms에 시작
      .add(
        {
          targets: { value: start },
          value: end,
          update: (anim) => {
            const currentValue = anim.animations[0]?.currentValue;
            $percentage.textContent = `${Math.round(Number(currentValue)).toLocaleString()}`;
          },
        },
        0,
      ); // 0ms에 시작 (동시 실행)
  }

  destroy() {
    if (this.timeline) {
      this.timeline.pause();
    }
  }
}
